import { render } from "./CompaniesPage.vue?vue&type=template&id=d7d9503c&ts=true"
import script from "./CompaniesPage.vue?vue&type=script&lang=ts"
export * from "./CompaniesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Admin/Companies/CompaniesPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d7d9503c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d7d9503c', __exports__)) {
    api.reload('d7d9503c', __exports__)
  }
  
  module.hot.accept("./CompaniesPage.vue?vue&type=template&id=d7d9503c&ts=true", () => {
    api.rerender('d7d9503c', render)
  })

}


export default __exports__